export default "/images/vendor/flag-icon-css/flags/4x3/sy.svg?6529aa17e46f775a39317b1ed78a526d";